export const isProductQuantityPerSizeEnabled = (sizeSettings, sizeDependentPrice) => {
  return !!(sizeSettings && sizeSettings.options.length > 1 && !sizeDependentPrice);
};